module.exports = __webpack_public_path__ + "media/images/flags/ve-02985f30df285b97ab529ce9b12a4ab2.svg";